/** The Firmark engraved seal — the PE-stamp brand motif. Concentric rings
 *  (optionally a dashed "tick ring"), the three-chevron mark, a serif
 *  wordmark, and a two-line byline. Single-color via `currentColor`. */
export function FirmarkSeal({
  size = 132,
  color = "currentColor",
  tickRing = true,
}: {
  size?: number;
  color?: string;
  tickRing?: boolean;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 150 150"
      role="img"
      aria-label="Firmark seal"
      style={{ display: "block" }}
    >
      <circle cx="75" cy="75" r="70" fill="none" stroke={color} strokeWidth="2" />
      {tickRing && (
        <circle cx="75" cy="75" r="64" pathLength="360" fill="none" stroke={color} strokeWidth="4.5" strokeDasharray="1.6 3.4" />
      )}
      <circle cx="75" cy="75" r="56" fill="none" stroke={color} strokeWidth="1" />
      <path d="M70 45 L75 40 L80 45" fill="none" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M65 54 L75 44 L85 54" fill="none" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M60 63 L75 53 L90 63" fill="none" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      {/* Literal font stacks — var() does not resolve in an SVG presentation attribute. */}
      <text x="75" y="89" textAnchor="middle" fontFamily='"IBM Plex Serif", Georgia, serif' fontSize="21" fontWeight="500" fill={color}>Firmark</text>
      <text x="75" y="104" textAnchor="middle" fontFamily='"Inter", sans-serif' fontSize="8.5" letterSpacing="1.5" fill={color}>automated</text>
      <text x="75" y="115" textAnchor="middle" fontFamily='"Inter", sans-serif' fontSize="8.5" letterSpacing="1.5" fill={color}>design</text>
    </svg>
  );
}
